<div class="container-fluid">
    <div class="title-tab-step text-center">
      {{ 'ApproveCycleSecLoginId' | translate }} 
    </div>

   
  <!--table area-->
  <!--header for column name & field for column content-->
  <div class="row p-3">
    <p-dataTable class="table table-responsive" tableStyleClass="table table-bordered table-striped" [value]="alertApprovCycleTransList"
                 [selectionMode]="'single'" [rows]="10" [paginator]="true" [pageLinks]="3"    [lazy]="true"
                 [rowsPerPageOptions]="[5,10,20,50,100]"    [rowStyleClass]="getCSSClasses">
      <p-column field="{{translate.currentLang == 'ar'? 'fullnameAr': 'fullnameEn'}}" header="{{ 'EMPLOYEENAME' | translate }}" [sortable]="true"></p-column>
      <p-column field="overrideLowerLevel" header="{{ 'overrideLowerLevel' | translate }}" [sortable]="true">
        <ng-template pTemplate="options" let-row="rowData">
            <i class="fa" [ngClass]="{'fa-check-square': row['overrideLowerLevel'] == 1,'fa-square-o':row['overrideLowerLevel'] == 0}"></i>
          </ng-template>
    </p-column>
      <p-column field="{{translate.currentLang == 'ar'? 'jobTitleNameAr': 'jobTitleNameEn'}}" header="{{ 'JOPTITEL' | translate }}" [sortable]="true"></p-column>
      <p-column field="{{translate.currentLang == 'ar'? 'decisionAr': 'decisionEn'}}" header="{{ 'STATUS' | translate }}" [sortable]="true"></p-column>
      <p-column *ngIf="!fromEmployeePortal" header="{{ 'MAKEDECISION'| translate }}" [sortable]="true">
        <ng-template pTemplate="options" let-row="rowData">
            <div class="col-sm-12" *ngIf="row.approveCycleSecLoginId == row.secLoginId">
                <sanabel-selectize appcode="424" [simpleView]="true" [(ngModel)]="row.decision"  [disabled]="row.rowStatus  == 3   ? true : false"
                    name="decision" (clicked)="makeDesision($event,row)">
                </sanabel-selectize>
            </div> 
        </ng-template>
    </p-column>
    <p-column header="{{ 'NOTES'| translate }}" [sortable]="true">  
      <ng-template pTemplate="options" let-row="rowData">
          <div *ngIf="row.rowStatus  != 3">
              <input class="form-control"  [(ngModel)]="row.notes" name="notes"  required />
          </div>
          <div  *ngIf="row.rowStatus  == 3">
            <input class="form-control"  [(ngModel)]="row.notes" name="notes"  required  disabled/>
        </div> 
          
      </ng-template>
  </p-column>
  <p-column styleClass="col-button"   *ngIf="SecLoginRoleId">
    <ng-template pTemplate="options" let-row="rowData">
        <icon-action (clicked)="onRowIconClick($event , row)" [appCodes]="[7214, 7215 ]"></icon-action>
    </ng-template>
</p-column>
    </p-dataTable>
  </div>
  <div class="row" *ngIf="!fromEmployeePortal">
    <div class="col">
      <btns-ctrl #btnCtrl1 [appCodes]="[1]" (clicked)="onClicked($event)"></btns-ctrl>
    </div>
  </div>
</div>  